import { AttributeValueClient } from '@frontend/attribute/api';
import { AttributeValue, AttributeValueQueryParams } from '@frontend/attribute/types';
import { ObjectSelectInput, ObjectSelectProps } from '@frontend/components/basic-forms';
import React, { useState } from 'react';

const ID = 'attribute-value-select';
export const AttributeValueSelectV2 = (props: ObjectSelectProps<AttributeValue, AttributeValueQueryParams>) => {
    const [q, cQ] = useState<AttributeValue | null>(null);
    return (
        <ObjectSelectInput<AttributeValue, AttributeValueQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || 'Attribute Value'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cQ(v);
            }}
            disabled={props.disabled}
            required={props.required}
            queryParams={props.queryParams}
            value={q}
            idValue={props.value || q?.id}
            fetch={(props) => AttributeValueClient.fetchAttributeValues(props)}
            itemLabel={(o) => o.value}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'attribute_value_id',
                          fetch: (pathParam) =>
                              AttributeValueClient.resolveAttributeValues([pathParam]).then((r) => {
                                  return r.results[0];
                              })
                      }
                    : undefined
            }
            isClearable={props.isClearable}
            subset={props.subset}
            disableFetch={props.disableFetch}
        />
    );
};
